



























































































import { Component, Vue } from 'vue-property-decorator';
import { emailApis, MailingListRecord } from '@/api/email.api';
import { employeeApis } from '@/api/employee.api';

@Component
export default class AddMembersDialog extends Vue {
  dialogVisible = false;
  currentList: MailingListRecord | null = null;
  searchQuery = '';
  availableMembers: { email: string; display_name: string }[] = [];
  loadingMembers = false;
  selectedFromAvailable = '';
  pendingMembers: { email: string; display_name: string }[] = [];
  submitting = false;

  open(listRecord: MailingListRecord) {
    this.currentList = { ...listRecord };
    this.searchQuery = '';
    this.availableMembers = [];
    this.selectedFromAvailable = '';
    this.pendingMembers = [];
    this.dialogVisible = true;
    this.loadAvailableMembers();
  }

  handleClose() {
    this.dialogVisible = false;
    this.currentList = null;
    this.searchQuery = '';
    this.availableMembers = [];
    this.selectedFromAvailable = '';
    this.pendingMembers = [];
  }

  get pendingMembersEmails(): string[] {
    return this.pendingMembers.map(m => m.email);
  }

  async loadAvailableMembers() {
    try {
      this.loadingMembers = true;
      const employees = await employeeApis.search({ name: this.searchQuery, internal: true });
      this.availableMembers = employees;
    } catch (error) {
      this.$message.error(`获取可添加成员失败: ${error.message || error}`);
    } finally {
      this.loadingMembers = false;
    }
  }

  addToPending() {
    if (!this.selectedFromAvailable) {
      return;
    }
    const selectedMember = this.availableMembers.find(m => m.email === this.selectedFromAvailable);
    if (selectedMember && !this.pendingMembersEmails.includes(selectedMember.email)) {
      this.pendingMembers.push({ ...selectedMember });
    }
    this.selectedFromAvailable = '';
  }

  removeFromPending(member: { email: string; display_name: string }) {
    const index = this.pendingMembers.map(m => m.email).indexOf(member.email);
    if (index > -1) {
      this.pendingMembers.splice(index, 1);
    }
  }

  async handleSubmit() {
    if (!this.currentList || this.pendingMembers.length === 0) {
      return;
    }

    try {
      await this.$confirm(`确定要添加选中的 ${this.pendingMembers.length} 个成员吗？`, '添加成员确认', {
        type: 'warning'
      });
    } catch {
      return;
    }

    try {
      this.submitting = true;
      await emailApis.mailingListsModify(this.currentList.name, {
        action: 'addItem',
        members: this.pendingMembers.map(m => m.email)
      });
      this.$message.success('添加成员成功');
      this.$emit('success');
      this.handleClose();
    } catch (error) {
      this.$message.error(`添加成员失败: ${error.message || error}`);
    } finally {
      this.submitting = false;
    }
  }
}
